import {
  BlockContentValue,
  InputForm,
  InputFormProps
} from "@silversea-ssc/ui-components-react";
import React, { useCallback, useState } from "react";
import { FormDisclaimerFragment } from "types/graphql-types";
import { useLingui } from "@lingui/react/macro";
import { INavLink } from "components/HeaderNavBar/type";
import { TokenValues } from "@silversea-ssc/dotcom-read-model-types/Tokens";
const SubscribeModal = React.lazy(
  () => import("../SubscribeModal/SubscribeModal")
);

type Props = {
  formTitle: BlockContentValue | undefined;
  formContent: BlockContentValue | undefined;
  formDisclaimerContent: FormDisclaimerFragment | undefined;
  formName: string;
  formVariant?: InputFormProps["variant"];
  formButtonVariant?: InputFormProps["buttonVariant"];
  showCrossBrandOptions?: boolean;
  onRequestClose?: () => void;
  onFormSubmitted?: () => void;
  privacyPolicyUrl: INavLink;
  offerPageUrl: string | undefined;
  tokens?: TokenValues;
};

const SubscribeInlineForm: React.FC<React.PropsWithChildren<Props>> = ({
  formTitle,
  formContent,
  formDisclaimerContent,
  formName,
  onRequestClose,
  onFormSubmitted,
  privacyPolicyUrl,
  formButtonVariant = "primary",
  formVariant = "transparent",
  offerPageUrl,
  tokens
}) => {
  const { t } = useLingui();
  const [modalState, setModalState] = useState({
    isOpen: false,
    email: ""
  });

  const onSubmitAction: React.FormEventHandler<HTMLFormElement> = useCallback(
    (event) => {
      event.preventDefault();
      setModalState({
        isOpen: true,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        email: (event.target as any).email.value
      });
    },
    []
  );

  const onModalRequestClose = useCallback(() => {
    setModalState({
      ...modalState,
      isOpen: false
    });
    if (onRequestClose) {
      onRequestClose();
    }
  }, [modalState, onRequestClose]);

  const onModalFormSubmitted = useCallback(() => {
    if (onFormSubmitted) {
      onFormSubmitted();
    }
  }, [onFormSubmitted]);

  return (
    <React.Fragment>
      <InputForm
        id="footer-subscribe-form"
        placeholder={t`Your e mail address`}
        formAction="#"
        inputType="email"
        name="email"
        variant={formVariant}
        icon="action"
        buttonVariant={formButtonVariant}
        dataContentPiece="sign_up_for_offers"
        onSubmitAction={onSubmitAction}
      />

      {modalState.isOpen && (
        <React.Suspense fallback={<div></div>}>
          <SubscribeModal
            email={modalState.email}
            isOpen={modalState.isOpen}
            onRequestClose={onModalRequestClose}
            onFormSubmitted={onModalFormSubmitted}
            formTitle={formTitle}
            formContent={formContent}
            formName={formName}
            formDisclaimerContent={formDisclaimerContent}
            privacyPolicyUrl={privacyPolicyUrl}
            offerPageUrl={offerPageUrl}
            tokens={tokens}
          ></SubscribeModal>
        </React.Suspense>
      )}
    </React.Fragment>
  );
};

export default React.memo(SubscribeInlineForm);
